// extracted by mini-css-extract-plugin
export var backdropBlur = "_ml-0";
export var contentCard = "_ml-5";
export var frame = "_ml-2";
export var image = "_ml-4";
export var imagePane = "_ml-3";
export var modal = "_ml-1";